let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("bTdk8")]).then(() => parcelRequire('dMvBS'));